import "whatwg-fetch";
import isDeviceSupported from "./isDeviceSupported";
import querystring from "./querystring";

export default {
	onLoad: () => (state, actions) => {

		const qs = querystring();
		const deviceSupported = isDeviceSupported();

		const minTime = new Promise(resolve => {
			setTimeout(resolve, state.splashTimeout);
		});

		const checkOrderPromise = fetch("/claim-your-ticket/check-registered" + window.location.search).then(r => {
			if (r.status !== 200) throw new Error("Error getting order: " + r.status);
			return r;
		});

		Promise.all([minTime, checkOrderPromise])
			.then(x => actions.splashScreenLoadCompleted())
			.catch(e => actions.setErrorScreen());
		return Object.assign({}, state, {
			orderId: qs.id,
			accessKey: qs.accesskey || qs.accessKey,
			custodianName: qs.name || "your custodian",
			brand: qs.brand || "cabcharge",
			deviceSupported,
			downloadUrl: "/claim-your-ticket/download" + window.location.search,
			screen: "loading",
			debugscreen: qs.debugscreen
		});
	},
	onBlur: value => (state, actions) => {
		actions.onFocus();
		return state;
	},
	onFocus: value => (state, actions) => {
		return Object.assign({}, state, {
			processing: false,
			screen: "instructions"
		});
	},
	splashScreenLoadCompleted: value => (state, actions) => {
		const valid = state.orderId && state.accessKey;

		if (!valid) return Object.assign({}, state, {
			processing: false,
			screen: "error"
		});

		if (!state.deviceSupported) {
			return Object.assign({}, state, {
				processing: false,
				screen: "not-supported"
			});
		}

		const autoDownloadPass = !window.location.pathname.endsWith("downloaded");

		function triggerDownload() {
			if (window.history && window.history.pushState)
				window.history.pushState({}, "Pass Downloading", "downloaded" + window.location.search);
			if (autoDownloadPass) window.location.href = state.downloadUrl;
		}

		window.onfocus = function () {
			actions.onFocus();
		};

		if (autoDownloadPass)
			setTimeout(triggerDownload, 500);

		//Can't relay on the focus / blur events to change to the instructions screen, certain iphones don't trigger the events.
		return Object.assign({}, state, {
			processing: false,
			screen: "instructions"
		});;
	},
	setErrorScreen: _ => (state, actions) => Object.assign({}, state, {
		screen: "error"
	}),
	sendNotification: value => (state, actions) => {
		fetch("/claim-your-ticket/notification", {
			method: "POST",
			headers: {
				"Content-Type": "application/json"
			},
			body: JSON.stringify({
				id: state.orderId
			})
		}).then(r => {
			return r.status == 200 ? actions.sendNotificationSuccess() : actions.sendNotificationError();
		});

		return Object.assign({}, state, {
			processing: true
		});
	},
	sendNotificationSuccess: value => (state, actions) => {
		return Object.assign({}, state, {
			processing: false,
			screen: "send-notification-success"
		});
	},
	sendNotificationError: value => (state, actions) => {
		return Object.assign({}, state, {
			processing: false,
			screen: "send-notification-error"
		});
	}
};